import Regex from '../Regex'

export default class AlphaUpperNum extends Regex {
  get ruleName () {
    return 'alphaUpperNum'
  }

  passes () {
    return super.passes(/^[A-ZÀ-Ý\d]+$/)
  }
}
